import ComponentFactory from './ComponentFactory.js';
import Icons from './utils/Icons.js';

class Main {
  constructor() {
    this.init();
  }

  init() {
    document.documentElement.classList.add('has-js');

    Icons.load();

    new ComponentFactory();

    document.addEventListener('DOMContentLoaded', () => {
      const loadingScreen = document.querySelector('#loading-screen');

      if (!loadingScreen) return;

      const startTime = Date.now();
      const minimumLoadingTime = 1000;

      function hideLoadingScreen() {
        const elapsed = Date.now() - startTime;
        const remainingTime = Math.max(0, minimumLoadingTime - elapsed);

        setTimeout(() => {
          loadingScreen.classList.add('is-hidden');

          // Retire le loading screen après la transition
          setTimeout(() => {
            loadingScreen.remove();
          }, 850);
        }, remainingTime);
      }

      // Attend que les ressources de la page soient chargées
      if (document.readyState === 'complete') {
        hideLoadingScreen();
      } else {
        window.addEventListener('load', hideLoadingScreen, { once: true });
      }
    });
  }
}
new Main();
